exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1isQAjPXYwlUqy{color:#42526e!important}._1isQAjPXYwlUqy:hover{color:#172b4d!important}", ""]);

// exports
exports.locals = {
	"closeButton": "_1isQAjPXYwlUqy"
};